var Options = {
  props: {
    options: {
      type: Object,
      default: function () { return ({}); }
    }
  }
};

export default Options;
